import type { DiscoveredRouteModule } from '@/router/generator/types';

const AdminMediaView = () => import('@/views/admin/MediaView.vue');
export const NAME_ADMIN_MEDIA = 'AdminMedia';
export const PATH_ADMIN_MEDIA = 'media';

export const route: DiscoveredRouteModule = {
  id: 'admin.media',
  scope: 'admin',
  moduleKey: 'media',
  name: NAME_ADMIN_MEDIA,
  path: PATH_ADMIN_MEDIA,
  component: AdminMediaView,
  meta: { requiresAdmin: true, dataLoaders: ['project_document', 'features', 'project_media'] },
};
